import * as React from 'react';
import { Component } from 'react';

export class Callback extends Component {
  public render() {
    return (<div/>);
  }
}
